import React from 'react';
import './App.css';
import {makeStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container'

//Components
import PrivateRoute from './component/PrivateRoute'
import MenuMain from './component/MenuMain'
import {isAuthenticaded} from './services/Authentication'

/** pages **/
import Login from './pages/Login'
import DatasetAdd from './pages/Dataset/datasetAdd'
import Dataset from './pages/Dataset/dataset'
import Connectors from './pages/Connectors'
import ConnectorAdd from './pages/Connectors/connectorAdd'
import DashboardFlexMonster from './pages/Dashboard/Dashboard'
import PivotModule from './pages/Modules/PivotModule'
import DatasetOrders from './pages/Dataset/DatasetOrders'
import DashboardPage from './pages/Modules/DashboardPage'
import EmbedPage from "./pages/Modules/EmbedPage";
import DashboardList from "./pages/DashboardAdmin/DashboardList";
import DashboardAdd from "./pages/DashboardAdmin/DashboardAdd";

import {Route, Switch, useLocation} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: 20,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },

    bar: {
        backgroundColor: 'rgba(0,0,0,.8)',
    },
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },

}));


function App() {

    const classes = useStyles();
    const isAuth = isAuthenticaded()
    const location = useLocation();


    const isEmbed = () => {
        if(location.pathname.indexOf("embed/") > -1) {
            return true;
        } else {
            return false
        };
    }

    const getEmbed = () => {
        return <div className={classes.root}>
            <Container className={classes.root} maxWidth="xl">
                <PrivateRoute path="/embed/dashboard/:id">
                    <EmbedPage/>
                </PrivateRoute>
            </Container>
        </div>;
    }

    const getMenu = () => {
        return <div className={classes.root}>

        {isAuth && (<MenuMain/>)}


        </div>
    }

    return (
        <div className={classes.root}>

            {(isEmbed() === false && isAuth) ? <MenuMain/> : ''}

            <Container className={classes.root} maxWidth="xl">
                <Switch>

                    <Route path="/embed/dashboard/:id">
                        <EmbedPage/>
                    </Route>

                    <PrivateRoute exact path="/">
                        <DashboardFlexMonster/>
                    </PrivateRoute>

                    <Route path="/Login">
                        <Login/>
                    </Route>

                    <PrivateRoute exact path="/dataset">
                        <Dataset/>
                    </PrivateRoute>

                    <PrivateRoute exact path="/dataset/add">
                        <DatasetAdd/>
                    </PrivateRoute>

                    <PrivateRoute path="/dataset/add/:id">
                        <DatasetAdd/>
                    </PrivateRoute>

                    <PrivateRoute exact path="/connectors">
                        <Connectors/>
                    </PrivateRoute>

                    <PrivateRoute exact path="/connectors/add">
                        <ConnectorAdd/>
                    </PrivateRoute>

                    <PrivateRoute path="/connectors/add/:id">
                        <ConnectorAdd/>
                    </PrivateRoute>

                    <PrivateRoute path="/dataset/order">
                        <DatasetOrders/>
                    </PrivateRoute>

                    <PrivateRoute path="/pivot/module/:id">
                        <PivotModule/>
                    </PrivateRoute>

                    <PrivateRoute path="/pivot/dashboard/:id">
                        <DashboardPage/>
                    </PrivateRoute>

                    <PrivateRoute path="/dashboad/list">
                        <DashboardList/>
                    </PrivateRoute>

                    <PrivateRoute exact path="/dashboard/add">
                        <DashboardAdd/>
                    </PrivateRoute>

                    <PrivateRoute path="/dashboard/add/:id">
                        <DashboardAdd/>
                    </PrivateRoute>

                </Switch>
            </Container>
        </div>
    );
}

export default App;
